import axios from 'axios';
import { API_CALL_ERROR, BRANCHES_ENDPOINT } from './APIConstants';

export async function getBranches() {
  try {
    const { data } = await axios.get(BRANCHES_ENDPOINT, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}

export async function getBranchById(id) {
  try {
    const { data } = await axios.get(BRANCHES_ENDPOINT, {
      params: {
        branchId: id,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}
